var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -6 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "letter",
    d: "M317,337a5.005,5.005,0,0,1-5-5V306a4.975,4.975,0,0,1,1-3h0a5,5,0,0,1,4-2h38a5,5,0,0,1,4,2h0a4.974,4.974,0,0,1,1,3v26a5.005,5.005,0,0,1-5,5Zm0-2h38a2.984,2.984,0,0,0,1.738-.556l-14.721-14.721-3.129,3.08a4.129,4.129,0,0,1-5.775,0l-3.129-3.081-14.721,14.721A2.984,2.984,0,0,0,317,335Zm-3-29v26a2.984,2.984,0,0,0,.555,1.737l14.716-14.715-14.825-14.6A2.982,2.982,0,0,0,314,306Zm43.445,27.737A2.983,2.983,0,0,0,358,332V306a2.981,2.981,0,0,0-.447-1.573l-14.825,14.6Zm-23.61-11.644a3.1,3.1,0,0,0,4.332,0l18.717-18.427A2.987,2.987,0,0,0,355,303H317a2.986,2.986,0,0,0-1.883.666Z",
    transform: "translate(-312 -301)",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49e01107c7d95752e29cef951d791cb6.svg";
export { ForwardRef as ReactComponent };